import { render, staticRenderFns } from "./NotificationDetailTable.vue?vue&type=template&id=4efa6844&"
import script from "./NotificationDetailTable.vue?vue&type=script&lang=ts&"
export * from "./NotificationDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDetailTable.vue?vue&type=style&index=0&id=4efa6844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports